import * as React from 'react'
import { cn } from '../../lib/cn'
import { Label } from '../atoms/Label'

/**
 * FormField — Label + Control + Help + Error. Pencil iRE8y UCOrt BmCkL.
 *
 * Composes the control via `children` so any atom (Input, Select, Textarea,
 * PhoneInput, etc.) can sit inside.
 */
export interface FormFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  label?: React.ReactNode
  htmlFor?: string
  required?: boolean
  hint?: string
  description?: React.ReactNode
  error?: React.ReactNode
}

export const FormField = React.forwardRef<HTMLDivElement, FormFieldProps>(
  ({ className, label, htmlFor, required, hint, description, error, children, ...props }, ref) => (
    <div ref={ref} className={cn('flex flex-col gap-1', className)} {...props}>
      {label && (
        <Label htmlFor={htmlFor} required={required} hint={hint}>
          {label}
        </Label>
      )}
      {description && <p className="text-caption text-ia-text-tertiary">{description}</p>}
      {children}
      {error && (
        <p className="text-caption text-ia-error flex items-center gap-1" role="alert">
          {error}
        </p>
      )}
    </div>
  ),
)
FormField.displayName = 'FormField'
